module.exports = __webpack_public_path__ + "img/p-icon.94cc059c.png";